import {
  createContext,
  createElement,
  type ReactElement,
  useContext,
  useMemo,
  useReducer,
} from 'react';
import { type Mutation, reducer } from './mutations';
import { type State } from './types';

export interface MemberStatusStore {
  state: State;
  dispatch: React.Dispatch<Mutation>;
}

const MemberStatusContext = createContext<MemberStatusStore>(
  {} as MemberStatusStore,
);

export function MemberStatusStoreProvider({
  children,
}: {
  children: ReactElement;
}) {
  const [state, dispatch] = useReducer(reducer, {
    lookup: {},
    list: [],
    loaded: false,
  });
  const props = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return createElement(
    MemberStatusContext.Provider,
    { value: props },
    children,
  );
}

export function useMemberStatusStore() {
  return useContext(MemberStatusContext);
}
